/*
 * @Descripttion : 考试管理API
 * @Author       : pishengjun
 * @Date         : 2021-08-11 10:49:57
 * @LastEditors : Please set LastEditors
 * @LastEditTime: 2026-01-21 18:04:12
 * @FilePath     : \examinee_web\src\http\api\workFlow.ts
 */

import axios from "@/utils/request";
import { RequestEnum, ServiceGateWay } from "@/utils/enum";
import type { SubjectsModel } from "../interfaceModel/ZhuoFan_Wb_SubjectService_WebApi";
import { store } from "@/store";
import type { ExamineeCurrentFlowNodeAndDetailModel } from "../interfaceModel/ExamineeCurrentFlowNodeAndDetailModel";
import type { CurrentExamFlowModel } from "../interfaceModel/currentExamFlowModel";
import type { ExamineeNodeActionRecordModel } from "../interfaceModel/ExamineeNodeActionRecordModel";
import type { ParticipateExamsModel } from "../interfaceModel/exam";

const documentAPI = `${ServiceGateWay.DOCUMENT}/examinee`;
const ExamineeDictionaries = `${ServiceGateWay.DICTIONARY}/ExamineeDictionaries`;
const examFlow = `${ServiceGateWay.EXAMINEE}`;
const positonAPI = `${ServiceGateWay.ORGANIZATION}/examinee/position`;
const subjectAPI = `${ServiceGateWay.SUBJECT}/examinee`;
const orderAPI = `${ServiceGateWay.ORDER}/Examinee`;
const orderSucess = `${ServiceGateWay.ORDER}/Order`;
const EXAMINEE = `${ServiceGateWay.EXAMINEE}`;
// * 工作流相关
const WorkFlow = {
  GET: {
    //获取文书详情
    getArticleInfo: (id: any, tenantId: string) => {
      return axios({
        url: `${documentAPI}/article/${id}`,
        method: RequestEnum.GET,
        options: {
          tenantId: tenantId,
        },
      });
    },
    //获取职位详情
    getPositionInfo: (id: any, tenantId: string) => {
      return axios({
        url: `${positonAPI}/${id}`,
        method: RequestEnum.GET,
        options: {
          tenantId: tenantId,
        },
      });
    },
    //根据订单获取订单信息
    getSubjectInfo: (id: string, tenantId: string) => {
      return axios<SubjectsModel[]>({
        url: `${subjectAPI}/subjectType/${id}/subjects`,
        method: RequestEnum.GET,
        options: {
          tenantId: tenantId,
        },
      });
    },
    //获取当前考试流程
    async getCurrentExamFlow(tenantId: string): Promise<CurrentExamFlowModel> {
      const currentExamFlow = await axios<any>({ url: `${examFlow}/ExamineeExtremityFlowDesignService/CurrentExamFlow`, method: RequestEnum.GET, options: { tenantId } });
      currentExamFlow.canvas = JSON.parse(currentExamFlow.canvas);
      store.commit("SET_USER_OPERATION_EXAMMAP", {
        tenantId: tenantId,
        data: { examFlow: currentExamFlow },
      });
      return currentExamFlow;
    },
    //考生端获取考生的详细信息与当前流程相关的配置
    async ExamineeCurrentFlowNodeAndDetail(exmineeId: string, tenantId: string): Promise<ExamineeCurrentFlowNodeAndDetailModel> {
      const examineeCurrentFlowNodeAndDetail = await axios<ExamineeCurrentFlowNodeAndDetailModel>({
        url: `${examFlow}/ExamineeExtremityFlowDesignService/ExamineeCurrentFlowNodeAndDetail/${exmineeId}`,
        method: RequestEnum.GET,
        options: {
          tenantId: tenantId,
        },
      });
      store.commit("SET_USER_OPERATION_EXAMMAP", {
        tenantId: tenantId,
        data: { examineeCurrentFlowNodeAndDetail },
      });
      return examineeCurrentFlowNodeAndDetail;
    },
    //获取考试流程时间表
    async getTimeTable(exmineeId: string, tenantId: string) {
      const examineeNodeActionRecord = await axios<ExamineeNodeActionRecordModel[]>({
        url: `${examFlow}/ExamineeExtremityExamineeService/ExamineeNodeActionRecord/${exmineeId}`,
        options: {
          tenantId: tenantId,
        },
      });
      store.commit("SET_USER_OPERATION_EXAMMAP", {
        tenantId: tenantId,
        data: { examineeNodeActionRecord },
      });
      return examineeNodeActionRecord;
    },
    //解析流程按钮跳转
    getJumpButton: (params: any, tenantId) => {
      return axios({
        url: `${examFlow}/ExamineeExtremityFlowDesignService/AnalysisFlowJumpButton`,
        method: RequestEnum.GET,
        params: params,
        options: {
          tenantId: tenantId,
        },
      });
    },
    //获取当前考生的白名单限制清单（定向职位）
    getLimitRoster: (idCard: string, tenantId) => {
      return axios({
        url: `${EXAMINEE}/ExamineeExtremityBlackWhiteRosterService/LimitRoster/${idCard}`,
        method: RequestEnum.GET,
        options: {
          tenantId: tenantId,
        },
      });
    },
    //根据身份证判断是否是退费考生
    refundExaminee: (idCard: string, tenantId) => {
      return axios({
        url: `${orderAPI}/RefundExaminee/${idCard}`,
        method: RequestEnum.GET,
        options: {
          tenantId: tenantId,
        },
      });
    },
  },
  POST: {
    async ParticipateExams(idCard: any, data: any, tenantId) {
      let list = await axios<ParticipateExamsModel[]>({
        url: `${examFlow}/ExamineeExtremityExamineeService/ParticipateExams/${idCard}`,
        method: RequestEnum.POST,
        options: {
          noTransform: true,
          tenantId: tenantId,
        },
        data,
      });
      list = list.map((item: any) => {
        item["idCard"] = idCard;
        return item;
      });
      return list;
    },
    //考生执行流程
    async execteFlow(data: any, tenantId: string): Promise<ExamineeCurrentFlowNodeAndDetailModel> {
      const examineeCurrentFlowNodeAndDetail = await axios<ExamineeCurrentFlowNodeAndDetailModel>({
        url: `${examFlow}/ExamineeExtremityFlowDesignService/ExecuteFlowAction`,
        method: RequestEnum.POST,
        data,
        options: { noTransform: true, tenantId },
      });
      store.commit("SET_USER_OPERATION_EXAMMAP", {
        tenantId: tenantId,
        data: { examineeCurrentFlowNodeAndDetail },
      });
      return examineeCurrentFlowNodeAndDetail;
    },
    //考生报名
    async examineeApply(data: any, relationRequestForKey: string, tenantId: string) {
      const examineeCurrentFlowNodeAndDetail = await axios<ExamineeCurrentFlowNodeAndDetailModel>({
        url: `${examFlow}/ExamineeExtremityExamineeService`,
        method: RequestEnum.POST,
        options: {
          noTransform: true,
          relationRequestForKey: relationRequestForKey,
          tenantId,
        },
        data,
      });
      store.commit("SET_USER_OPERATION_EXAMMAP", {
        tenantId: tenantId,
        data: { examineeCurrentFlowNodeAndDetail },
      });
      return examineeCurrentFlowNodeAndDetail;
    },
    // 判断考生是否在指定的环节
    isExamineeNodeVerify(examineeId: string, nodeId: string, tenantId: string) {
      return axios({
        url: `${examFlow}/ExamineeExtremityExamineeService/NodeVerify/${examineeId}/${nodeId}`,
        method: RequestEnum.POST,
        options: {
          noTransform: true,
          tenantId,
        },
      });
    },
    //创建支付订单
    createOrder(data: any, tenantId) {
      return axios({
        url: `${orderAPI}/Order`,
        method: RequestEnum.POST,
        data,
        options: {
          noTransform: true,
          tenantId,
        },
      });
    },
    //根据机构Id和分组编码检查是否配置支付方式
    accessCheckPayment(data: any, tenantId) {
      return axios({
        url: `${orderAPI}/Order/AccessCheckPayment`,
        method: RequestEnum.POST,
        data,
        options: {
          noTransform: true,
          tenantId,
        },
      });
    },

    // 考生端 补充字典数据
    getSupplementary(data: any, tenantId) {
      return axios({
        url: `${ExamineeDictionaries}/SupplementaryDictionaryData/Supplementary`,
        method: RequestEnum.POST,
        data,
        options: {
          tenantId: tenantId,
        },
      });
    },
    // 考生端 补充字典数据
    getSupplementaryNew(data: any, tenantId) {
      return axios({
        url: `${ExamineeDictionaries}/NewSupplementary/NewSupplementary`,
        method: RequestEnum.POST,
        data,
        options: {
          noTransform: true,
          tenantId: tenantId,
        },
      });
    },
    //发送支付成功事件
    postPaySucess(data: any, tenantId) {
      return axios({
        url: `${orderSucess}/PaymentSuccess`,
        method: RequestEnum.POST,
        data,
        options: {
          noTransform: true,
          tenantId,
        },
      });
    },
  },
  PATCH: {
    // 订单申请退费
    orderForRefund(data: any, tenantId) {
      return axios({
        url: `${orderAPI}/Order/ApplyForRefund`,
        method: RequestEnum.PATCH,
        data,
        options: {
          noTransform: true,
          tenantId,
        },
      });
    },
  },
};

export default { WorkFlow };
